module.exports = __webpack_public_path__ + "static/media/icon-send.54580c38.svg";